export class KudoModel {
	constructor(userId: number, kudoId: number) {
		this.userId = userId;
		this.kudoId = kudoId;
	}

	userId: number;
	kudoId: number;
}
